import { render, staticRenderFns } from "./CreateEmailAuthRecordsModal.vue?vue&type=template&id=42e4afa1&scoped=true"
import script from "./CreateEmailAuthRecordsModal.vue?vue&type=script&lang=js"
export * from "./CreateEmailAuthRecordsModal.vue?vue&type=script&lang=js"
import style0 from "./CreateEmailAuthRecordsModal.vue?vue&type=style&index=0&id=42e4afa1&prod&lang=scss&rel=stylesheet%2Fscss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42e4afa1",
  null
  
)

export default component.exports